import { Outlet } from 'react-router-dom';
import { useServices } from '../../hooks/useServices';
import { useDownCountTitle } from '../../hooks/useDocumentTitle';
import { BottomBarProvider } from '../../context/BottomBarContext';
import { Header } from './Header';
import { MobileNav } from './MobileNav';

export function Layout() {
  const { data: services } = useServices();
  const downCount = services?.filter(s => s.status === 'down').length ?? 0;
  useDownCountTitle(downCount);

  return (
    <BottomBarProvider>
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
        <a
          href="#main"
          className="sr-only focus:not-sr-only focus:absolute focus:z-50 focus:top-2 focus:left-2 focus:px-3 focus:py-2 focus:rounded-md focus:bg-brand-600 focus:text-white focus:text-sm"
        >
          Skip to content
        </a>
        <Header />
        {/* Clears whatever occupies the bottom bar slot; 0 from `md` up. */}
        <main
          id="main"
          className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 pb-[calc(var(--pc-bottom-bar-h)_+_1.5rem)]"
        >
          <Outlet />
        </main>
        {/* The same count the tab title carries — the reason to glance at a
            phone at all, so it belongs on the bar too. */}
        <MobileNav downCount={downCount} />
      </div>
    </BottomBarProvider>
  );
}
